// Framer Motion animations (see: https://www.framer.com/api/motion/animation/#variants)
export const mobilePanelAnimations = {
  default: {
    x: 0,
    transition: {
      ease: 'anticipate',
      duration: 0.25,
    },
  },
  collapsed: {
    x: '-100%',
    transition: {
      ease: 'easeOut',
      duration: 0.2,
    },
  },
}

export const desktopPanelAnimations = {
  default: {
    x: 0,
    transition: {
      ease: 'anticipate',
      duration: 0.25,
    },
  },
  collapsed: {
    x: 'calc(-100% + 24px)',
    transition: {
      ease: 'easeOut',
      duration: 0.2,
    },
  },
}
